export default {
    home: "Inicio",
    projects: "Cursos",
    community: "Comunidad",
    customization: "Personalización",
    reports: "Informes",
    marketing: "Marketing",
    settings: "Ajustes",
    my_account: 'Mi cuenta',
    annual_sales: "Ventas anuales",
    sales: "Ventas",
    students: "Estudiantes",
    teachers: "Docentes",
    products: "Productos",
    // TEMPORAL: mostramos "Cursos" en vez de "Productos" en el dashboard y el menú lateral,
    // hasta que se implementen los tipos de producto — revertir o ajustar cuando eso ocurra.
    // No usar esta clave en Pedidos/Ventas: ahí se usa "products" (arriba), que debe seguir diciendo "Productos".
    products_temp: "Cursos",
    project: "Proyectos",
    categories: "Categorías",
    category: 'Categoría',
    published: "Publicado",
    name: "Nombre",
    lastname: 'Apellidos',
    email: "Email",
    phone: "Teléfono",
    title: "Título",
    pass: 'Contraseña',
    pass_confirm: 'Confirmación de contraseña',
    coming_soon: "Próximamente",
    month: "Mes",
    year: "Año",
    date: "Fecha",
    plan: 'Plan',
    pvp: "PVP",
    net: "Neto",
    total: 'Total',
    state: "Estado",
    delete: "Eliminar",
    profile: "Perfil",
    enrollments: "Matriculaciones",
    cancel: "Cancelar",
    save: "Guardar",
    remove: 'Borrar',
    email_address: 'Dirección de correo',
    image_format: 'PNG, JPG, GIF hasta 3MB',
    close: 'Cerrar',
    back: 'Volver',
    coming_soon_brainspro: 'Próximamente en Brainspro',
    and: 'y',
    product: "Producto",
    date_creation: 'Fecha de creación',
    type: 'tipo',

    //AppComponent
    my_profile: 'Mi Perfil',
    adjust: 'Ajustes',
    out: 'Salir',
    search: 'Buscar',
    academy_preview: 'Previsualizar academia',
    my_academy: 'Mi Academia',
    new_project: 'Nuevo Curso',
    text_current_period: 'Tu periodo de prueba ',
    text_end_at: ' acaba en ',
    plans: 'Planes',
    billing: 'Facturación',

    //ThankYouPageComponent
    thankyou: '¡Gracias!',
    go_to_academy: 'Ir a la academia',

    //NavigationDesktop - Mobile
    records: 'Grabaciones',
    videos: 'Videos',

    //Aviso de cambios sin guardar (FE-032)
    unsaved_changes_title: 'Tienes cambios sin guardar',
    unsaved_changes_text: 'Si sales ahora, se perderán los cambios que no has guardado.',
    unsaved_changes_leave: 'Salir sin guardar',
    unsaved_changes_stay: 'Seguir editando',

    // FE-043 · RouteTabsComponent
    tabs: 'Pestañas',

    // Botón Aula (Moodle)
    classroom_ready_title: 'El aula está lista',
    classroom_ready_text: 'El navegador ha bloqueado la pestaña nueva. Pulsa «Abrir aula» para entrar al curso.',
    classroom_open: 'Abrir aula',
    classroom_timeout: 'Moodle está tardando demasiado en responder. Inténtalo de nuevo en unos minutos.',
    classroom_error: 'No se ha podido abrir el aula del curso.',

    // Menú de navegación
    users: 'Usuarios',
    navigation_menu: 'Menú de navegación',
    open_menu: 'Abrir menú',
    close_menu: 'Cerrar menú',
}
